"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PromoCodeTemplatesCountriesList_1 = require("./PromoCodeTemplatesCountriesList");
var PromoCodeTemplatesCountriesEdit_1 = require("./PromoCodeTemplatesCountriesEdit");
var PromoCodeTemplateCountries = /** @class */ (function (_super) {
    __extends(PromoCodeTemplateCountries, _super);
    function PromoCodeTemplateCountries(props) {
        return _super.call(this, props) || this;
    }
    PromoCodeTemplateCountries.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AC = this.props.listAppCountries.Subscribe("*", function (id, data) {
            _this.setState({ availCountry: data.data });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            availCountry: []
        }, function () {
            _this.props.listAppCountries.LoadData();
        });
        this.props.state.setExtBreadCrumbPath(["Промокоды", "Страны шаблонов промокодов"]);
    };
    PromoCodeTemplateCountries.prototype.componentWillUnmount = function () {
        this.props.listAppCountries.UnSubscribe(this.SID_AC);
    };
    PromoCodeTemplateCountries.prototype.onGoBackToTopPageClick = function () {
        if (this.props.onGoBackClick) {
            this.props.onGoBackClick();
        }
    };
    PromoCodeTemplateCountries.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    PromoCodeTemplateCountries.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    PromoCodeTemplateCountries.prototype.getBrandCountriesRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(PromoCodeTemplatesCountriesEdit_1.default, { state: this.props.state, data: this.props.dataCountries, rootRecord: this.props.record, onGoBack: this.onGoBackClick.bind(this), availCountry: this.state.availCountry }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(PromoCodeTemplatesCountriesList_1.default, { state: this.props.state, data: this.props.dataCountries, rootRecord: this.props.record, onGoBackClick: this.onGoBackToTopPageClick.bind(this), onNewClick: this.onNewClick.bind(this) }));
        }
    };
    PromoCodeTemplateCountries.prototype.render = function () {
        return (React.createElement("div", null, this.getBrandCountriesRenderObject()));
    };
    return PromoCodeTemplateCountries;
}(React.Component));
exports.default = PromoCodeTemplateCountries;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_promocodes/ui/component/countries/PromoCodeTemplateCountries.tsx
// module id = 1966
// module chunks = 0